import { useState } from 'react';
import { SectionType, TabWrap } from 'sections/TabWrap';

import { FileInput } from 'components/FileInput';

import * as S from './Images.styles';

export function Images(): React.ReactElement {
  // eslint-disable-next-line
  const [file, fileSet] = useState<File>();

  const sections: SectionType[] = [
    {
      id: 1,
      content: (
        <S.Container>
          <FileInput onChange={fileSet} />
        </S.Container>
      ),
    },
  ];

  return <TabWrap sections={sections} />;
}
